/** Organisation-level sections, by the path segment after `/orgs/$orgId`. */
const SECTIONS: Record<string, string> = {
  team: "Team",
  settings: "Settings",
  plan: "Plan & billing",
  usage: "Usage",
  network: "Shared Loyalty",
  integrations: "Integrations",
  "provider-spend": "Integrations Spend",
};

/** Pages inside a section, by the path segment after the section's own. */
const PAGES: Record<string, string> = {
  choose: "Choose a plan",
  checkout: "Checkout",
  invoices: "Invoices",
  acceptance: "Acceptance",
  credits: "AI credit charges",
};

/**
 * The breadcrumb after the studio's name for an organisation-level path:
 * `/orgs/1/plan/invoices` is `["Plan & billing", "Invoices"]`. The studio's
 * own home has none, and a section this does not know draws none rather than
 * a raw segment.
 */
export function orgTrail(pathname: string): string[] {
  const [, orgs, , section, page] = pathname.split("/");
  if (orgs !== "orgs" || !section) return [];
  const name = SECTIONS[section];
  if (!name) return [];
  const inside = page ? PAGES[page] : undefined;
  return inside ? [name, inside] : [name];
}
